
import React, { useState, useEffect } from 'react'
import Base from '../../Base';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Api from '../../Services/ApiCall';
import toast, { Toaster } from 'react-hot-toast';
import Base64Downloader from 'react-base64-downloader';
import { triggerBase64Download } from 'react-base64-downloader';
import Swal from 'sweetalert2';
import {
    validEmailRegex,
    validPasswordRegex,
    validOnlyEmailRegex,
    validPhoneNumberRegex,
    numberMethod,
    maxLength
} from '../../CommanRules';
import Select from 'react-select';

export default function JobSeekerForm() {

    const navigate = useNavigate();
    const location = useLocation();
    const { ID, Flag } = location.state;

    useEffect(() => {
        if (ID != 0) {
            BindGrid(ID)
            Get(ID)
        }
        GetQualification()
        GetPlandetail()
        GetAmount()
        GetCountryList()
        GetCityList()
        GetDistrict()
        GetExperience()
        GetSex()
        GetSalary()
    }, []);

    const [aadharnumber, setAadharno] = useState("");
    const [name, setName] = useState("");
    const [dob, setDob] = useState("");
    const [uploadFile, setuploadFile] = useState("");
    const [mobilenumber, setMobilenumber] = useState("");
    const [email, setEmail] = useState("");
    const [qualification, setQualification] = useState([]);
    const [sexList, setSexList] = useState([]);
    const [experienceList, setExperienceList] = useState([]);
    const [salaryList, setSalaryList] = useState([]);
    const [filename, setfilename] = useState("");
    const [plan, setPlan] = useState("");
    const [amount, setAmount] = useState([]);
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [pincode, setPincode] = useState("");
    const [CountryList, setCountryList] = useState();
    const [StateList, setStateList] = useState();
    const [CityList, setCityList] = useState();
    const [selectedPlan, setselectedPlan] = useState("");
    const [selectedQualiify, setselectedQualiify] = useState([]);
    const [formFields12, setFormFields] = useState([
        { companyname: '', designation: '', years: '', month: '' },
    ])
    const [district1, setDistrict1] = useState([]);
    const [formFields, setFormField] = useState([
        { qualify: '', course: '', institution: '', passedout: '' },
    ])
    const [emailid1, setEmailid1] = useState("");
    const [Companyname1, setCompanyname1] = useState("");

    const [qualification_brief, setQualification_brief] = useState("");
    const [skills, setSkills] = useState("");
    const [sex, setSex] = useState("");
    const [salary_Expectation, setSalary_Expectation] = useState("");
    const [experience, setExperience] = useState("");

    useEffect(() => {
        CompanyGet()
    }, []);
    async function CompanyGet(id) {
        var Param = { Mstcompanyprofileid: 3 }
        var url = "/Company/BindCompany";
        let _response = await Api.BindGrid(Param, url)
        setCompanyname1(_response[0].Companyname);
        setEmailid1(_response[0].Emailid);
    }
    const handleFormChange = (event, index, F) => {
        let data = [...formFields12];
        if (F == 1) {
            data[index].companyname = event.target.value;
        } if (F == 2) {
            data[index].designation = event.target.value;
        } if (F == 3) {
            data[index].years = event.target.value;
        } if (F == 4) {
            data[index].month = event.target.value;
        }
        setFormFields(data);
    }
    const handleFormChange1 = (event, index, F) => {

        let data = [...formFields];
        if (F == 1) {
            data[index].qualify = event.target.value;
        } if (F == 2) {
            data[index].course = event.target.value;
        } if (F == 3) {
            data[index].institution = event.target.value;
        } if (F == 4) {
            data[index].passedout = event.target.value;
        }
        setFormField(data);
    }
    const addFields = () => {
        let object = { companyname: '', designation: '', years: '', month: '' }

        setFormFields([...formFields12, object])
    }

    const removeFields = (index) => {
        let data = [...formFields12];
        data.splice(index, 1)
        setFormFields(data)
    }

    const addFields1 = () => {
        let object = { qualify: '', course: '', institution: '', passedout: '' }

        setFormField([...formFields, object])
    }
    const removeFields1 = (index) => {
        let data = [...formFields];
        data.splice(index, 1)
        setFormField(data)
    }
    async function GetCountryList() {
        let _response = await Api.DirectApiCall('country', "", "")
        setCountryList(_response)
    }
    async function GetStateList(value) {
        setCountry(value)
        var Param = { country: value }
        let _response = await Api.DirectApiCall('state', value)
        setStateList(_response.states)
    }
    async function GetCityList(value) {
        setState(value)
        // var url = "/DropDown/GetCities";
        // let _response = await Api.BindDropdown(url)
        // let Arry_Title1 = [];
        // setCityList(_response)
    }

    const [district, setDistrict] = useState("");
    const [districtlist, setDistrictlist] = useState("")

    async function GetDistrict() {

        var url = "/DropDown/GetDistrict";
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setDistrictlist(_response)
    }

    async function GetPlandetail() {

        var url = "/DropDown/GetPlandetail";
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setPlan(_response)
    }

    async function GetAmount(e) {
        setselectedPlan(e.target.value)
        var id = (e.target.value)
        var url = "/DropDown/GetPlandetailamount?id=" + id;
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setAmount(_response)
    }

    async function GetQualification() {

        var url = "/DropDown/GetQualification";
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setQualification(_response)
    }
    async function GetSex() {

        var url = "/DropDown/GetMaster_name?mastername=Sex";
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setSexList(_response)
    }
    async function GetExperience() {

        var url = "/DropDown/GetMaster_name?mastername=Experience";
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setExperienceList(_response)
    }
    async function GetSalary() {

        var url = "/DropDown/GetMaster_name?mastername=Salary";
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setSalaryList(_response)
    }
    async function BindGrid(id) {
        var Param = { mstjobseekerid: ID }
        var url = "/JobSeekerTable/BindJobSeekerTable";
        let _response = await Api.BindGrid(Param, url)
        var Files = _response[0].Filedocument;
        var type = Files.split(";")[0].split('/')[1];
        var test = Files.split(",")[1];
        setfile(test);
        setfiletype(type)
        setfilename(_response[0].Filename)
    }

    const uploadImage = async (e) => {
        const file = e.target.files[0];
        var filename = file.name;
        setfilename(filename)
        const base64 = await convertBase64(file);
        setuploadFile(base64);
    }

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    }
    const [agree, setAgree] = useState(false);
    async function IUDOperation() {
        var AadharNo = aadharnumber;
        var Name = name;
        var Dateofbirth = dob;
        var Mobilenumber = mobilenumber;
        var Email = email;
        var Qualification = qualification;
        var Aadhar = aadharnumber;
        var UploadFile = uploadFile;
        var SelectedQualiify = selectedQualiify;
        var Country = country;
        var State = state;
        var City = city;
        var Address = address;
        var Pincode = pincode;
        var Plan = selectedPlan;
        var Amount = amount;
        var Agree = agree;

        if (Name == "") {
            toast.error('Please enter a Name')
            return false;
        }

        if (Mobilenumber == "") {
            toast.error('Please Enter  Mobile  Number')
            return false;
        }
        else {
            if (!(Mobilenumber.length == 10)) {
                toast.error('Please Enter 10 Digit Mobile  Number')
                return false;
            }
        }

        if (!(validOnlyEmailRegex.test(Email))) {
            toast.error('Please enter a Valid EmailId')
            return false;
        }
        if (selectedQualiify == "") {
            toast.error('Please Select Qualification')
            return false;
        }
        if (district == "") {
            toast.error('Please Select District')
            return false;
        }
        if (UploadFile == "") {
            toast.error('Please Upload Resume')
            return false;
        }
        if (password == "") {
            toast.error('Please Enter Password')
            return false;
        }
        if (confirmPassword == "") {
            toast.error('Please Enter Confirm Password')
            return false;
        }
        if (password != confirmPassword) {
            toast.error('Please Enter Password and Confirm Password Same')
            return false;
        }
        if (Agree == "") {
            toast.error('Please Approve Agree')
            return false;
        }

        var Param = {

            "mstjobseekerid": ID,
            "mstjobseekercode": "",
            "name": Name,
            "dataofbirth": Dateofbirth,
            "mobilenumber": Mobilenumber,
            "qualifcation": JSON.stringify(formFields12),
            "education": JSON.stringify(formFields),
            "usertype": JSON.stringify(selectedDistricts),
            "email": Email,
            "aadhaarnumber": Aadhar,
            "filedocument": UploadFile,
            "filename": filename,
            "active": "",
            "searchField": "",
            "flag": Flag,
            "createdBy": 0,
            "createdDate": " ",
            "subscribe": "",
            "plantype": "",
            "planperiod": "",
            "activestatus": "",
            "planamount": 0,
            "mstqualifcation": SelectedQualiify,
            "country": Country,
            "state": State,
            "city": City,
            "pincode": Pincode,
            "address": Address,
            "plan": sessionStorage.getItem("AccessType"),
            "district": district,
            "sex": sex,
            "qualification_brief": qualification_brief,
            "skills": skills,
            "salary_expectation": salary_Expectation,
            "experience": experience,
            "password": password,
            "createdFrom":"Web"
        };

        var url = "/JobSeekerTable/IUDJobSeekerTable";
        let _response = await Api.IUD(Param, url);
        showAlert(_response);
        setTimeout(() => {
            navigate('/Jobseeker_table')
        }, 2000)

    }

    const showAlert = (_response) => {
        Swal.fire({
            title: "Success",
            text: _response,
            icon: "success",
            confirmButtonText: "OK",
        });
    };
    const [file, setfile] = useState()
    const [filetype, setfiletype] = useState()


    function base64toPDF(data, types) {

        var bufferArray = base64ToArrayBuffer(data);
        var blobStore = new Blob([bufferArray]);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blobStore);
            return;
        }
        var data = window.URL.createObjectURL(blobStore);
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = data;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(data);
        link.remove();
    }

    function base64ToArrayBuffer(data) {
        var data1 = data.replace('data:documents/pdf;base64,', '');
        var bString = window.atob(data1);
        var bLength = bString.length;
        var bytes = new Uint8Array(bLength);
        for (var i = 0; i < bLength; i++) {
            var ascii = bString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    };
    async function Get(id) {
        var Param = { Mstjobseekerid: id }
        var url = "/JobSeekerTable/BindJobSeekerTable";
        let _response = await Api.BindGrid(Param, url)
        setAadharno(_response[0].Aadhaarnumber);
        setName(_response[0].Name);
        setDob(_response[0].Dataofbirth);
        setMobilenumber(_response[0].Mobilenumber);
        setEmail(_response[0].Email);
        setFormFields(JSON.parse(_response[0].Qualifcation));
        setSelectedDistricts(JSON.parse(_response[0].Usertype));
        setselectedQualiify(_response[0].Mstqualifcation);
        setCountry(_response[0].Country);
        setState(_response[0].State);
        setCity(_response[0].City);
        setAddress(_response[0].Address);
        setPincode(_response[0].Pincode);
        setselectedPlan(_response[0].Plan);
        setAmount(_response[0].Planamount);
        setDistrict(_response[0].District);
        setfilename(_response[0].Filename)
        var Files = _response[0].Filedocument;
        var type = Files.split(";")[0].split('/')[1];
        var test = Files.split(",")[1];
        setfiletype(type)
        setfile(test);
        setFormField(JSON.parse(_response[0].Education));
    }
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [selectedLocationOptions, setSelectedOptions] = useState([]);
    const handleChange = (selectedOptions) => {

        const isValueSelected = selectedLocationOptions.some((option) => option.label === selectedOptions[0].value);
        if (!isValueSelected) {
            const newOption = {
                label: selectedOptions[0].value,
            };
            setSelectedOptions((prevSelectedOptions) => [...prevSelectedOptions, newOption]);
        }

        setSelectedDistricts(selectedOptions);
    };

    const [formValues, setFormValues] = useState([{ responses: "" }])

    let newFormValues = [];
    let addFormFields = () => {
        setFormValues([...formValues, { prospect_statement: "" }])
    }
    const [add, setAdd] = useState("")

    const [showTermsConditions, setShowTermsConditions] = useState(false);
    const handleTermsConditionsClick = () => {
        setShowTermsConditions(true);
    };

    const handleClosePopup = () => {
        setShowTermsConditions(false);
    };

    const districtOptions = Array.isArray(districtlist)
        ? districtlist.map((district) => ({
            value: district.Text,
            label: district.Text
        }))
        : [];

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: '1px solid #ced4da',
            borderRadius: '.25rem',
            minHeight: 'calc(1.5em + .75rem + 2px)',
            padding: '.375rem .75rem',
            fontSize: '1rem',
            lineHeight: '1.5',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0',
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#e9ecef',
            borderRadius: '.2rem',
            padding: '0 .5rem',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#495057',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#495057',
            ':hover': {
                backgroundColor: '#ced4da',
                color: '#212529',
            },
        }),
    };

    const handleRemove = (labelToRemove) => {
        setSelectedDistricts((prevSelected) =>
            prevSelected.filter((item) => item.label !== labelToRemove)
        );
        setSelectedOptions((prevSelected) =>
            prevSelected.filter((item) => item.label !== labelToRemove)
        );
    };

    async function GetCityValue(value) {
        setDistrict(value)
        var Param = { districtName: value, cityName: "" }
        var url = "/CommanAPI/GetCity";
        let _response = await Api.BindGrid(Param, url)
        setCityList(_response)
    }

    return (
        <div>
            <Toaster toastOptions={{ position: "top-right" }} />
            <div>

                <Base Jobseekercreate={true} />
                <div id="main" class="main">
                    <div class="pagetitle">
                        <nav>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><Link to="/dash">Home</Link></li>
                                <li class="breadcrumb-item">Registration</li>
                                <li class="breadcrumb-item active">Jobseeker Registration</li>
                            </ol>
                        </nav>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Jobseeker Creation</h5>
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <label for="name"> Name</label>
                                    <input type="text" class="form-control" disabled={Flag == "D" || Flag == "V" ? true : false} value={name} placeholder="Name" onChange={(e) => setName(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="Sex"> Sex</label>
                                    <select id="inputState" class="form-select" value={sex} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setSex(e.target.value)}  >
                                        <option selected>Sex</option>
                                        {sexList &&
                                            sexList.map((i, index) => (
                                                <option value={i.id}>{i.Text1}</option>
                                            ))}
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="aadharnumber">Aadhar Number</label>
                                    <input type="text" class="form-control no-spinner" disabled={Flag == "D" || Flag == "V" ? true : false} value={aadharnumber} placeholder="Aadhar no" onChange={(e) => setAadharno(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="dob"> Date of Birth</label>
                                    <input type="date" max={new Date().toISOString().split("T")[0]} class="form-control" value={dob} disabled={Flag == "D" || Flag == "V" ? true : false} placeholder="Date of birth" onChange={(e) => setDob(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="mobilenumber"> Mobile Number</label>
                                    <input type="number" class="form-control no-spinner" placeholder="Mobile number" disabled={Flag == "D" || Flag == "V" ? true : false} value={mobilenumber} onChange={(e) => setMobilenumber(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="email">Email Id</label>
                                    <input type="email" class="form-control" placeholder="Email" value={email} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setEmail(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="qualification"> Qualifcation</label>
                                    <select id="inputState" class="form-select" value={selectedQualiify} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setselectedQualiify(e.target.value)}  >
                                        <option selected>Qualification</option>
                                        {qualification &&
                                            qualification.map((i, index) => (
                                                <option value={i.id}>{i.Text}</option>
                                            ))}
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="Please enter brief your Qualifcation">Please enter brief your Qualifcation</label>
                                    <input type="text" class="form-control" placeholder="Please enter brief your Qualifcation" value={qualification_brief} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setQualification_brief(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="Skills">Skills</label>
                                    <input type="text" class="form-control" placeholder="Skills" value={skills} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setSkills(e.target.value)} />
                                </div>

                                <div class="col-md-4">
                                    <label for="Salary Expectation"> Salary Expectation</label>
                                    <select id="inputState" class="form-select" value={salary_Expectation} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setSalary_Expectation(e.target.value)}  >
                                        <option selected>Salary Expectation</option>
                                        {salaryList &&
                                            salaryList.map((i, index) => (
                                                <option value={i.id}>{i.Text1}</option>
                                            ))}
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="Experience"> Experience</label>
                                    <select id="inputState" class="form-select" value={experience} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setExperience(e.target.value)}  >
                                        <option selected>Experience</option>
                                        {experienceList &&
                                            experienceList.map((i, index) => (
                                                <option value={i.id}>{i.Text1}</option>
                                            ))}
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label for="country">Country</label>
                                    <select id="inputState" class="form-select" disabled={Flag == "D" || Flag == "V" ? true : false} value={country} onChange={(e) => GetStateList(e.target.value)}>
                                        <option selected>Country</option>
                                        {/* {CountryList?.map((i, index) => (
                                            <option value={i.country.toLowerCase()}>{i.country}</option>
                                        ))} */}
                                        <option value="india">India</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="state">State</label>
                                    <select id="inputState" class="form-select" disabled={Flag == "D" || Flag == "V" ? true : false} value={state} onChange={(e) => GetCityList(e.target.value)}>
                                        <option selected >State</option>
                                        {/* {StateList?.map((i, index) => (
                                            <option value={i.name.toLowerCase()}>{i.name}</option>
                                        ))} */}
                                        <option value="tamil nadu">Tamil Nadu</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="district">District</label>
                                    <select id="inputState" class="form-select" disabled={Flag == "D" || Flag == "V" ? true : false} value={district} onChange={(e) => GetCityValue(e.target.value)}>
                                        <option selected >District</option>
                                        {districtlist &&
                                            districtlist.map((i, index) => (
                                                <option value={i.Text}>{i.Text}</option>
                                            ))}
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="city">City</label>
                                    <select id="inputState" class="form-select" disabled={Flag == "D" || Flag == "V" ? true : false} value={city} onChange={(e) => setCity(e.target.value)}>

                                        <option >City</option>
                                        {CityList?.map((i, index) => (
                                            <option value={i.CityName}>{i.CityName}</option>
                                        ))}
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label for="address">Address</label>
                                    <textarea class="form-control" placeholder="Address" value={address} disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => setAddress(e.target.value)} ></textarea>
                                </div>
                                <div class="col-md-4">
                                    <label for="pincode">Pincode</label>
                                    <input type="number" class="form-control no-spinner" maxLength={6} placeholder="Pincode" disabled={Flag == "D" || Flag == "V" ? true : false} value={pincode} onChange={(e) => setPincode(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="attachresume">Attach Resume</label>
                                    <input type="file" name="file" class="form-control" disabled={Flag == "D" || Flag == "V" ? true : false} onChange={(e) => uploadImage(e)} />
                                </div>
                                {/* <h5>Add Your Education Details</h5>
                                <div class="row g-3">
                                    {formFields.map((form1, index) => {
                                        return (
                                            <div className='row col-md-12' key={index}>
                                                <div className=' row col-md-10'>
                                                    <div className=' col-md-3'>
                                                        <label for="qualification"> Qualifcation</label>
                                                        <input
                                                            name='qualify' class="form-control col-md-3"
                                                            placeholder=' Qualification'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange1(event, index, 1)}
                                                            value={form1.qualify}
                                                        /></div>

                                                    <div className=' col-md-3'>
                                                        <label for="course"> Course</label>
                                                        <input
                                                            name='course' class="form-control col-md-3"
                                                            placeholder='Course'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            value={form1.course} onChange={event => handleFormChange1(event, index, 2)}

                                                        />
                                                    </div>
                                                    <div className=' col-md-3'>
                                                        <label for="instituionname">Institution Name</label>
                                                        <input
                                                            name='institution' class="form-control col-md-3"
                                                            placeholder='Institution Name'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange1(event, index, 3)}
                                                            value={form1.institution}
                                                        /></div>
                                                    <div className=' col-md-3'>
                                                        <label for="name">Passedout Year</label>
                                                        <input
                                                            name='passedout' type="date" class="form-control col-md-3"
                                                            placeholder='PassedOut year'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange1(event, index, 4)}
                                                            value={form1.passedout}
                                                        /></div>
                                                </div>
                                                <div className=' col-md-2'>
                                                    <button className='btn btn-warning' onClick={() => removeFields1(index)}>X</button>

                                                </div>
                                            </div>
                                        )
                                    })}
                                    <div className='col-md-3'>     <button class="btn btn-primary" onClick={addFields1}>Add</button></div>

                                </div>
                                <h5>Add Your Experience Details</h5>
                                <div class="row g-3">
                                    {formFields12.map((form, index) => {
                                        return (
                                            <div className='row col-md-12' key={index}>
                                                <div className=' row col-md-10'>
                                                    <div className=' col-md-3'>
                                                        <label for="companyname">Company Name</label>
                                                        <input
                                                            name='CompanyName' class="form-control col-md-3"
                                                            placeholder='CompanyName'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange(event, index, 1)}
                                                            value={form.companyname}
                                                        /></div>
                                                    <div className=' col-md-3'>
                                                        <label for="designation">Designation</label>
                                                        <input
                                                            name='Designation' class="form-control col-md-3"
                                                            placeholder='Designation'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange(event, index, 2)}
                                                            value={form.designation}
                                                        /></div>  <div className=' col-md-3'>
                                                        <label for="from"> From</label>
                                                        <input
                                                            name='Year' type="month" class="form-control col-md-3"
                                                            placeholder='Year'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange(event, index, 3)}
                                                            value={form.years}
                                                        /></div>
                                                    <div className=' col-md-3'>
                                                        <label for="to">To</label>
                                                        <input
                                                            name='Month' type="month" class="form-control col-md-3"
                                                            placeholder='Month'
                                                            disabled={Flag == "D" || Flag == "V" ? true : false}
                                                            onChange={event => handleFormChange(event, index, 4)}
                                                            value={form.month}
                                                        /></div>
                                                </div>
                                                <div className=' col-md-2'>
                                                    <button className='btn btn-warning' onClick={() => removeFields(index)}>X</button>

                                                </div>
                                            </div>
                                        )
                                    })}
                                    <div className='col-md-3'>     <button class="btn btn-primary" onClick={addFields}>Add</button></div>

                                </div> */}
                                <div class="col-md-4">
                                    <label for="Password">Password</label>
                                    <input type="text" class="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                </div>
                                <div class="col-md-4">
                                    <label for="cPassword">Confirm Password</label>
                                    <input type="text" class="form-control" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="district">Prefered location</label>
                                    <Select
                                        id="preferredLocation"
                                        isMulti
                                        classNamePrefix="select"
                                        options={districtOptions}
                                        value={[]}
                                        onChange={handleChange}
                                        placeholder="Prefared Location"
                                    />
                                </div>
                                <div className='row '>
                                    <div className='col-12'>
                                        <div class="d-flex align-content-start flex-wrap">
                                            {selectedLocationOptions.map((item01, index) => (
                                                <p key={index} className="drp-texttile">
                                                    <span>{item01.label}</span>
                                                    <span className="drpclose" onClick={() => handleRemove(item01.label)} style={{ cursor: 'pointer', marginLeft: '8px' }}
                                                    >
                                                        x
                                                    </span>
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {Flag == "V" ? null :
                                    <div>
                                        <input type='checkbox' checked={agree} onChange={(e) => { setAgree(!(agree)) }} />
                                        <span onClick={handleTermsConditionsClick} style={{ color: 'red', cursor: 'pointer' }}> I Agree the Terms & Conditions</span>
                                    </div>
                                }

                                <div class="text-center">
                                    <button type="button" disabled={Flag == "V" ? true : false} class="btn btn-primary" onClick={IUDOperation}>Submit</button>
                                    <button type="reset" class="btn btn-info"><Link to="/Jobseeker_table">Back</Link></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showTermsConditions && (
                <div className="login_popup-overlay">
                    <div className="login_popup">
                        <h2>Terms & Conditions</h2>
                        <p>
                            {/* <div>
                                <span style={{ fontWeight: 'Bold' }}> 1)Acceptance of Terms:</span> By using the website, you agree to the following terms and conditions.
                            </div> */}
                            <div>
                                This website is operated by <span style={{ fontWeight: 'Bold' }}>{Companyname1} </span>. Throughout the site, the terms “we”, “us” and “our” refer to <span style={{ fontWeight: 'Bold' }}>{Companyname1} </span>. <span style={{ fontWeight: 'Bold' }}>{Companyname1} </span>offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
                                By visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply  to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.
                                Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.
                                Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 1)ONLINE STORE TERMS:</span>
                            </div>
                            <div>
                                By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
                                You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).
                                You must not transmit any worms or viruses or any code of a destructive nature.
                                A breach or violation of any of the Terms will result in an immediate termination of your Services.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 2)GENERAL CONDITIONS:</span>
                            </div>
                            <div>
                                We reserve the right to refuse service to anyone for any reason at any time.
                                You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.
                                You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.
                                The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 3)ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION:</span>
                            </div>
                            <div>
                                We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.
                                This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.

                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 4)MODIFICATIONS TO THE SERVICE AND PRICES:</span>
                            </div>
                            <div>
                                Prices for our products are subject to change without notice.
                                We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.
                                We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 5)PRODUCTS OR SERVICES:</span>
                            </div>
                            <div>
                                Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy.
                                We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate.
                                We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited.
                                We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 6)ACCURACY OF BILLING AND ACCOUNT INFORMATION:</span>
                            </div>
                            <div>
                                We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors.
                                You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed.
                                For more detail, please review our Returns Policy.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 7)THIRD-PARTY LINKS:</span>
                            </div>
                            <div>
                                Certain content, products and services available via our Service may include materials from third-parties.
                                Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.
                                We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 8)PERSONAL INFORMATION:</span>
                            </div>
                            <div>
                                Your submission of personal information through the store is governed by our Privacy Policy.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 9)INDEMNIFICATION:</span>
                            </div>
                            <div>
                                You agree to indemnify, defend and hold harmless <span style={{ fontWeight: 'Bold' }}>{Companyname1} </span> and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 10)SEVERABILITY:</span>
                            </div>
                            <div>
                                In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 11)TERMINATION:</span>
                            </div>
                            <div>
                                The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes.
                                These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site.
                                If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 12)ENTIRE AGREEMENT:</span>
                            </div>
                            <div>
                                The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.
                                These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).
                                Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 13)GOVERNING LAW:</span>
                            </div>
                            <div>
                                These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of India .
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 14)CHANGES TO TERMS OF SERVICE:</span>
                            </div>
                            <div>
                                You can review the most current version of the Terms of Service at any time at this page.
                                We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.
                            </div>

                            <div>
                                <span style={{ fontWeight: 'Bold' }}> 15)CONTACT INFORMATION:</span>
                            </div>
                            <div>
                                Questions about the Terms of Service should be sent to us at <span style={{ fontWeight: 'Bold' }}>{emailid1} </span>.
                            </div>
                        </p>
                        <button onClick={handleClosePopup}>Close</button>
                    </div>
                </div>
            )}
        </div>
    )
}

